import React, { FC } from 'react';
import styles from './GalleryIcon.scss';

export const GalleryIcon: FC = () => <div className={styles.galleryIcon} />;
